export interface SubscriptionFormField {
    label: string;
    placeholder: string;
}

export interface SubscriptionType {
    type: string;
}

export interface CopSubscriptionConfig {
    actionType?: 'Add' | 'Edit' | 'add' | 'edit';
    title?: string;
    subscriptionForm?: SubscriptionFormField[];
    subscriptionTypes?: SubscriptionType[];
    requiredErrorText?: string;
    customerEmailDisabledText?: string;
    siteIdDisabledText?: string;
    confirmLabel?: string;
    confirmURL?: string;
    cancelLabel?: string;
    confirmation?: {
        successTitle?: string;
        successDescription?: string;
        errorTitle?: string;
        errorDescription?: string;
    };
    cancel?: {
        message?: string;
        subtext?: string;
        yesLabel?: string;
        yesUrl?: string;
        noLabel?: string;
    };
}

export interface CopSubscriptionProps {
    configJson?: string;
    'config-json'?: string;
}

function decodeHtmlEntities(str: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
}

export function parseConfig(raw: string): CopSubscriptionConfig {
    if (!raw) return {};
    try {
        return (JSON.parse(decodeHtmlEntities(raw)) as CopSubscriptionConfig) ?? {};
    } catch {
        return {};
    }
}
